import React from "react";
import { Box, Collapse, Typography, InputBase, Button } from "@mui/material";
import { noteMultilineSx, ghostButtonSx } from "bundles/Internal/components/common/FloatingTimer";

export default function RunningPanel({ open, selectedProject, note, setNote, onCancel }) {
  return (
    <Collapse in={open} unmountOnExit>
      <Box sx={{ px: 2.5, pb: 2, display: "flex", flexDirection: "column", gap: 1.25 }}>
        {selectedProject && (
          <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
            <Box sx={{ width: 8, height: 8, borderRadius: "50%", bgcolor: selectedProject.color, flexShrink: 0 }} />
            <Typography sx={{ fontSize: 13, fontFamily: "Segoe UI Semibold, sans-serif, system-ui", color: "hsl(150 30% 12%)" }} noWrap>
              {selectedProject.name}{selectedProject.company?.name ? ` — ${selectedProject.company.name}` : ""}
            </Typography>
          </Box>
        )}

        <InputBase
          value={note}
          onChange={(e) => setNote(e.target.value)}
          placeholder="Add a note (optional)"
          multiline
          minRows={3}
          maxRows={3}
          sx={noteMultilineSx}
        />

        <Button
          onClick={onCancel}
          sx={{
            ...ghostButtonSx,
            color: "hsl(0, 70%, 45%)",
            "&:hover": { backgroundColor: "hsla(0, 70%, 45%, 0.08)" },
          }}
        >
          Cancel timer
        </Button>
      </Box>
    </Collapse>
  );
}
